var modules_173205eb = {"container":"Radio_module_container__bd0dc79a","checked":"Radio_module_checked__bd0dc79a","control":"Radio_module_control__bd0dc79a","disabled":"Radio_module_disabled__bd0dc79a","read-only":"Radio_module_readOnly__bd0dc79a","input":"Radio_module_input__bd0dc79a","label":"Radio_module_label__bd0dc79a","icon":"Radio_module_icon__bd0dc79a"};
import "../../../assets/esm/components/Radio/src/Radio~WOu7hvCf.css";

export { modules_173205eb as default };
//# sourceMappingURL=Radio.module.less.js.map
